import { ProjectMetaInfo } from "../types/app.types";
import { isString } from "./typeChecks.utils";

export const getEntryPagePath = (p: string | ProjectMetaInfo) => {
  const slug = isString(p) ? p : p.name;
  return isString(p) ? `/projects/${slug}` : `/${p.type ?? 'project'}s/${slug}`;
}